import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import stripe_image from "../../../components/Images/payment_logo/stripe.svg";
import paypal_image from "../../../components/Images/payment_logo/paypal.svg";
import razorpay_image from "../../../components/Images/payment_logo/razorpay.svg";
import iyzico_image from "../../../components/Images/payment_logo/iyzico.svg";
import pesapal_image from "../../../components/Images/payment_logo/pesapal.svg";
import PayHere_image from "../../../components/Images/payment_logo/PayHere.svg";
import cashfree_image from "../../../components/Images/payment_logo/cashfree.svg"
import googlepay_image from "../../../components/Images/payment_logo/googlepay.svg"
import applepay_image from "../../../components/Images/payment_logo/applepay.svg"
import ideabiz_image from "../../../components/Images/payment_logo/ideabiz.png"
import "./PaymentSettings.css";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import { IconSolidEdit } from "../../../Assets/MyIcons";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
function PaymentSettings() {
  const { fetchRequest } = useMyContext()
  const baseUrl = process.env.REACT_APP_Baseurl
  const indexApi = `${baseUrl}/admin/payment-settings/index`

  const pesapalIndexApi = `${baseUrl}/admin/pesapal_payment/index`

  const [loading, setLoading] = useState(true)
  const [formData, setFormData] = useState({
    stripe: 0,
    iyzico: 0,
    paypal: 0,
    razorpay: 0,
    pesapal: 0,
    payhere:0,
    cashfree: 0,
    googlepay: 0,
    applepay: 0,
    ideabiz: 0,
  })

  const fetchData = async() => {
    const response = await fetchRequest({
      method : 'GET',
      url: `${indexApi}`,
      data: {}
    })
    if(response?.status){
      setFormData(prev => ({
        ...prev,
        stripe: response?.data?.stripe,
        iyzico: response?.data?.iyzico,
        paypal: response?.data?.paypal,
        razorpay: response?.data?.razorpay,
        pesapal: response?.data?.pesapal,
        payhere: response?.data?.payhere,
        cashfree: response?.data?.cashfree,
        googlepay: response?.data?.googlepay,
        applepay: response?.data?.applepay,
        ideabiz: response?.data?.ideabiz,
      }))
    }
  }

  useEffect(() => {
    fetchData()
  },[])



  return (
    <>

      <AdminSaveHeader className={`col-10`} heading={"Payment Settings"} hideButton/>
      <section className="theme-bg-color rounded-3 p-lg-4 p-3 ">
        <MessageHeading text={"RECOMMENDED SOLUTIONS"} className="mb-5" noMargin />
        {formData?.stripe ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={stripe_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Stripe Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Stripe provides a set of programmable APIs and tools  to let you facilitate payments and pay out sellers  globally." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/stripe_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {/* PayHere */}
        {formData?.payhere ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={PayHere_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="PayHere Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Payhere provides a set of programmable APIs and tools  to let you facilitate payments and pay out sellers  globally." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/payhere-settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {formData?.paypal ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={paypal_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Paypal Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="PayPal is a payment platform with a website and a  phone app that enables payments between parties  through online money transfers." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/paypal_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}
        {formData?.razorpay ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={razorpay_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Razorpay Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Razorpay has developed the Standard Checkout method and manages it. You can configure payment methods,  orders, company logo and also select custom colour  based on your convenience." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/razorpay_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}
        {formData?.iyzico ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={iyzico_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Iyzico Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="  Iyzico helps businesses like yours get paid quickly and securely from anyone, anywhere in the world." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/iyzico_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}
        {formData?.pesapal ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start">
            <img src={pesapal_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Pasapal Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="  Payment Anyware, Anytime." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/pesapel_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {/* Cashfree */}
        {formData?.cashfree ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start d-flex align-items-center justify-content-start p-2">
            <img src={cashfree_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Cashfree Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Accept payments via Cashfree with TEST and LIVE modes." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/cashfree_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {/* Google Pay */}
        {formData?.googlepay ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start d-flex align-items-center justify-content-start p-2">
            <img src={googlepay_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Google Pay Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Accept payments via Google Pay using your Product ID for seamless transactions." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/googlepay_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {/* Apple Pay */}
        {formData?.applepay ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start d-flex align-items-center justify-content-start p-2">
            <img src={applepay_image} alt="Image" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Apple Pay Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Accept payments via Apple Pay using your Product ID for seamless iOS transactions." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/applepay_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}

        {/* Ideabiz */}
        {formData?.ideabiz ? <div className="d-flex align-items-center justify-content-center mb-4 shadow p-3 rounded-4 flex-wrap">
          <div className="col-12  col-lg-2 text-start d-flex align-items-center justify-content-start p-2">
            <img src={ideabiz_image} alt="Ideabiz" className="payment-image" />
          </div>
          <div className="col-12 col-lg-8">
            <MessageLabel text="Ideabiz Checkout" noMargin className="mb-1" />
            <MessageSubHeading className="mb-2 mb-md-0" text="Accept payments via Ideabiz for Sri Lankan customers with local bank and mobile wallet support." noMargin />
          </div>
          <div className="col-12 col-lg-2 d-flex justify-content-end">
            <Link to="/ideabiz_settings" className="payment-image theme-text-color justify-content-center  theme-bg-color-secondary rounded-2 p-2 d-flex align-items-center gap-3">
              <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Configure" />
            </Link>
          </div>
        </div> : ""}
      </section>
    </>
  );
}
export default PaymentSettings;